var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M457 295L457 323",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 457.5,
    cy: 290.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M452.987 290.19C452.987 286.283 456.288 283.117 460.358 283.117C460.943 283.117 461.511 283.184 462.056 283.308C460.742 282.48 459.187 282 457.519 282C452.814 282 449 285.806 449 290.5C449 295.194 452.814 299 457.519 299C459.814 299 461.895 298.093 463.427 296.62C462.492 297.032 461.454 297.263 460.358 297.263C456.288 297.263 452.987 294.096 452.987 290.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M466.402 289.6L466.37 287.146L464.535 288.719L462.304 288.056L463.112 290.337L461.765 292.381L464.1 292.218L465.499 294.144L466.133 291.763L468.345 290.909L466.402 289.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch4);
export default __webpack_public_path__ + "static/media/church_4.e86d8b8ab08d5850792c4b14b14ab2fd.svg";
export { ForwardRef as ReactComponent };